// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RadiusSettingOutlinedSvg from "@ant-design/icons-svg/es/asn/RadiusSettingOutlined";
import AntdIcon from '../components/AntdIcon';

var RadiusSettingOutlined = function RadiusSettingOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RadiusSettingOutlinedSvg
  }));
};

RadiusSettingOutlined.displayName = 'RadiusSettingOutlined';
export default React.forwardRef(RadiusSettingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/RadiusSettingOutlined.js
// module id = 1667
// module chunks = 0